import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import 'isomorphic-fetch'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var createHttpRequestClientMethod = function createHttpRequestClientMethod() {
  var clientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (method, url, args) {
    // create a header entry specifying the origin DFDS application
    var customHeaders = {
      'X-Client-Id': clientId
    }; // https://github.com/okta/okta-auth-js/blob/master/packages/okta-auth-js/fetch/fetchRequest.js

    var body = args.data;
    var headers = args.headers || {};
    var contentType = headers['Content-Type'] || headers['content-type'] || '';

    if (contentType === 'application/json' && body && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return fetch(url, {
      method: method,
      headers: _objectSpread({}, headers, {}, customHeaders),
      body: body,
      credentials: args.withCredentials === false ? 'omit' : 'include'
    }).then(function (response) {
      var _response$headers, _response$headers$get, _response$headers$get2;

      var error = !response.ok;
      var status = response.status;

      var respHandler = function respHandler(resp) {
        var result = {
          responseText: resp,
          status: status
        }; // TODO: is this the correct way?

        if (error) {
          throw result;
        }

        return result;
      };

      if ((_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : (_response$headers$get = _response$headers.get('Content-Type')) === null || _response$headers$get === void 0 ? void 0 : (_response$headers$get2 = _response$headers$get.toLowerCase()) === null || _response$headers$get2 === void 0 ? void 0 : _response$headers$get2.includes('application/json')) {
        return response.json().then(respHandler);
      } else {
        return response.text().then(respHandler);
      }
    });
  };
};

export default createHttpRequestClientMethod;